import {
  queryMarketingActivityApi,
  addMarketingActivityApi,
  updateMarketingActivityApi,
  deleteMarketingActivityApi,
  setMarketingActivityStateApi,
  getMarketingActivityByIdApi,
  setMarketingActivitySortApi,
  getMarketingActivityMembersImproveApi,
  queryMejmActivityApi,
  addMejmActivityApi,
  getMejmActivityByIdApi,
  queryCardMakeRecordApi,
  addCardsApi,
  getCardMakeRecordBeanByIdApi,
  querySmsHistoryApi,
  querySmsTemplateApi,
  addSmsTemplateApi,
  updateSmsTemplateApi,
  setSmsTemplateApi,
  deleteSmsTemplateApi,
  queryTicketByIdsApi,
  queryDistributionActivityApi,
  saveOrUpdateDistributionActivityApi,
  getDistributionActivityByIdApi,
  getDistributionActivityPersonalReportApi,
  getDistributionActivityOrdersApi,
  updateDistributionActivityStateApi,
  getExportRecordIdInfoApi,
  getWechatAccountByConditApi,
  upPicUrlToWeChatApi,
  addWechatCardApi,
  updateWechatCardApi,
  getWechatCardByConditApi,
  queryZlchbActivityApi,
  updateZlchbStateApi,
  saveOrUpdateZlchbActivityApi,
  openZlchbApi,
  getZlchbActivityByIdApi,
  addSubCardActivityApi,
  updateSubCardActivityApi,
  queryCardUseWaterApi,
  updateRelationshipApi,
  anyoneJoinedInApi,
  getDistribtuionMsgByTelApi,
  queryTicketCenterApi,
  updateTicketCenterStateApi,
  addTicketCenterActivityApi,
  updateTicketCenterActivityApi,
  getTicketCenterDetailApi,
  querySignActivityApi,
  updateSignStateApi,
  addSignActivityApi,
  updateSignActivityApi,
  getSignActivityByIdApi,
  getBusinessOpporImportExtendByIdApi,
  updateMejmStateApi,
  setCommunityBuyingRuleApi,
  addCommunityLeaderApi,
  updateCommunityLeaderApi,
  setCommunityLeaderStateApi,
  queryCommunityLeaderApi,
  getCommunityBuyingRuleApi,
  getCommunityLeaderByIdApi,
  queryBrandUserRedAccountApi,
  agreeWithdrawalApi,
  sortMarketingActivityApi,
  queryDitrubtionGroupApi,
  updateMarketingActivitySortNumApi,
  saveDistributionActivityApi,
  getBrandDistributionActivityApi,
  updateDistributionStateApi,
  getDistributionSubsApi,
  getBrandDistributionPersonsApi,
  auditDistributionPersonApi,
  registerDistributionRelationshipApi,
  queryTicketTCSPListApi,
  receiveTicketTCSPApi,
  queryActivityCutListApi,
  addPrizeActivityApi,
  updatePrizeActivityApi,
  getPrizeActivityByIdApi,
  queryPrizeActivityForManageApi,
  getPrizeGoodsListAndWinPrizeNumApi,
  queryWinPrizePartakeAndPrizeGoodsApi,
  setPrizeActivityStateApi,
  getTicketBeanListApi,
  manualOpenPrizeApi,
  addBrandNoticeApi,
  deleteBrandNoticeApi,
  updateBrandNoticeApi,
  getBrandNoticeByIdApi,
  saveOrUpdateTakeoutConfigApi,
  getTakeoutConfigApi,
  getBrandNoticeListApi,
  applyForWithdrawalForAccountApi,
  getDisConfigByBrandIdApi,
  saveOrUpdateDisConfigApi,
  queryTopRegisterOrderApi,
  queryTakeoutOrderApi,
  queyrMovieOrderApi,
  queryBrandUserGroupApi,
  addBrandUserGroupApi,
  deleteBrandUserGroupApi,
  queryDisGoodsApi,
  queryExportRecordTotalApi,
  queryCardMakeRecordTotalApi,
  operateDistributorApi,
  saveOrUpdateBonusPoolConfigApi,
  getBrandBonusPoolConfigApi,
  queryTakeoutConfigApi,
  saveOrUpdateTbkRelationIdApi,
  queryTbkRelationIdsApi,
  saveOrUpdateTbkPidApi,
  queryTbkPidsApi,
  addShopOverlordBalanceApi,
  getGivenPeriodCardConfigApi,
  setGivenPeriodCardConfigApi
} from '@/api'
const state = {}
const getters = {}
const mutations = {}
const actions = {
  //  查询营销活动列表
  async queryMarketingActivityAction(context, param) {
    const res = await queryMarketingActivityApi(param)
    return res
  },
  //  添加营销活动
  async addMarketingActivityAction(context, param) {
    const res = await addMarketingActivityApi(param)
    return res
  },
  //  修改营销活动
  async updateMarketingActivityAction(context, param) {
    const res = await updateMarketingActivityApi(param)
    return res
  },
  //  删除营销活动
  async deleteMarketingActivityAction(context, param) {
    const res = await deleteMarketingActivityApi(param)
    return res
  },
  // 设置营销活动状态
  async setMarketingActivityStateAction(context, param) {
    const res = await setMarketingActivityStateApi(param)
    return res
  },
  // 根据id查询营销活动信息
  async getMarketingActivityByIdAction(context, param) {
    const res = await getMarketingActivityByIdApi(param)
    return res
  },
  // 设置营销活动排序
  async setMarketingActivitySortAction(context, param) {
    const res = await setMarketingActivitySortApi(param)
    return res
  },
  // 根据筛选条件获取人数
  async getMarketingActivityMembersImproveAction(context, param) {
    const res = await getMarketingActivityMembersImproveApi(param)
    return res
  },
  // 查询满额减列表
  async queryMejmActivityAction(context, param) {
    const res = await queryMejmActivityApi(param)
    return res
  },
  // 添加满额减活动
  async addMejmActivityAction(context, param) {
    const res = await addMejmActivityApi(param)
    return res
  },
  // 根据id获取满额减活动详情
  async getMejmActivityByIdAction(context, param) {
    const res = await getMejmActivityByIdApi(param)
    return res
  },
  // 分页查询制卡记录
  async queryCardMakeRecordAction(context, param) {
    const res = await queryCardMakeRecordApi(param)
    return res
  },
  // 制作卡
  async addCardsAction(context, param) {
    const res = await addCardsApi(param)
    return res
  },
  // 制作卡
  async getCardMakeRecordBeanByIdAction(context, param) {
    const res = await getCardMakeRecordBeanByIdApi(param)
    return res
  },
  // 查询短信
  async querySmsHistoryAction(context, param) {
    const res = await querySmsHistoryApi(param)
    return res
  },
  // 查询短信模板
  async querySmsTemplateAction(context, param) {
    const res = await querySmsTemplateApi(param)
    return res
  },
  // 添加短信模板
  async addSmsTemplateAction(context, param) {
    const res = await addSmsTemplateApi(param)
    return res
  },
  // 修改短信模板
  async updateSmsTemplateAction(context, param) {
    const res = await updateSmsTemplateApi(param)
    return res
  },
  // 设置短信模板
  async setSmsTemplateAction(context, param) {
    const res = await setSmsTemplateApi(param)
    return res
  },
  // 删除短信模板
  async deleteSmsTemplateAction(context, param) {
    const res = await deleteSmsTemplateApi(param)
    return res
  },
  // 根据电子券id查询电子券
  async queryTicketByIdsAction(context, param) {
    const res = await queryTicketByIdsApi(param)
    return res
  },
  // 分销活动分页查询
  async queryDistributionActivityAction(context, param) {
    const res = await queryDistributionActivityApi(param)
    return res
  },
  // 新增/更新分销活动
  async saveOrUpdateDistributionActivityAction(context, param) {
    const res = await saveOrUpdateDistributionActivityApi(param)
    return res
  },
  // 根据id获取分销活动详情
  async getDistributionActivityByIdAction(context, param) {
    const res = await getDistributionActivityByIdApi(param)
    return res
  },
  // 获取每个人参与分销活动的收益报表
  async getDistributionActivityPersonalReportAction(context, param) {
    const res = await getDistributionActivityPersonalReportApi(param)
    return res
  },
  // 获取分销订单信息
  async getDistributionActivityOrdersAction(context, param) {
    const res = await getDistributionActivityOrdersApi(param)
    return res
  },
  // 更改分销活动状态
  async updateDistributionActivityStateAction(context, param) {
    const res = await updateDistributionActivityStateApi(param)
    return res
  },
  // 获取导出卡信息
  async getExportRecordIdInfoAction(context, param) {
    const res = await getExportRecordIdInfoApi(param)
    return res
  },
  // 根据条件获取微信账号信息
  async getWechatAccountByConditAction(context, param) {
    const res = await getWechatAccountByConditApi(param)
    return res
  },
  // 上传网络图片到微信
  async upPicUrlToWeChatAction(context, param) {
    const res = await upPicUrlToWeChatApi(param)
    return res
  },
  // 添加微信卡信息
  async addWechatCardAction(context, param) {
    const res = await addWechatCardApi(param)
    return res
  },
  // 更新微信卡信息
  async updateWechatCardAction(context, param) {
    const res = await updateWechatCardApi(param)
    return res
  },
  // 根据条件查询微信卡信息
  async getWechatCardByConditAction(context, param) {
    const res = await getWechatCardByConditApi(param)
    return res
  },
  // 查询微助力活动
  async queryZlchbActivityAction(context, param) {
    const res = await queryZlchbActivityApi(param)
    return res
  },
  // 更改活动状态——微助力活动
  async updateZlchbStateAction(context, param) {
    const res = await updateZlchbStateApi(param)
    return res
  },
  // 新增微助力活动
  async saveOrUpdateZlchbActivityAction(context, param) {
    const res = await saveOrUpdateZlchbActivityApi(param)
    return res
  },
  // 助力者进行助力
  async openZlchbAction(context, param) {
    const res = await openZlchbApi(param)
    return res
  },
  // 获取微助力活动详情
  async getZlchbActivityByIdAction(context, param) {
    const res = await getZlchbActivityByIdApi(param)
    return res
  },
  // 添加次卡活动
  async addSubCardActivityAction(context, param) {
    const res = await addSubCardActivityApi(param)
    return res
  },
  // 更新次卡活动
  async updateSubCardActivityAction(context, param) {
    const res = await updateSubCardActivityApi(param)
    return res
  },
  // 查询卡使用流水
  async queryCardUseWaterAction(context, param) {
    const res = await queryCardUseWaterApi(param)
    return res
  },
  // 调整关系
  async updateRelationshipAction(context, param) {
    const res = await updateRelationshipApi(param)
    return res
  },
  // 查看品牌是否有人参与分销
  async anyoneJoinedInAction(context, param) {
    const res = await anyoneJoinedInApi(param)
    return res
  },
  // 根据电话号码查询分销信息
  async getDistribtuionMsgByTelAction(context, param) {
    const res = await getDistribtuionMsgByTelApi(param)
    return res
  },
  // 领券中心列表查询
  async queryTicketCenterAction(context, param) {
    const res = await queryTicketCenterApi(param)
    return res
  },
  // 修改领券中心活动状态
  async updateTicketCenterStateAction(context, param) {
    const res = await updateTicketCenterStateApi(param)
    return res
  },
  // 创建领券中心活动
  async addTicketCenterActivityAction(context, param) {
    const res = await addTicketCenterActivityApi(param)
    return res
  },
  // 修改领券中心活动
  async updateTicketCenterActivityAction(context, param) {
    const res = await updateTicketCenterActivityApi(param)
    return res
  },
  // 根据电话号码查询分销信息
  async getTicketCenterDetailAction(context, param) {
    const res = await getTicketCenterDetailApi(param)
    return res
  },
  // 查询签到活动列表
  async querySignActivityAction(context, param) {
    const res = await querySignActivityApi(param)
    return res
  },
  // 更新签到活动状态
  async updateSignStateAction(context, param) {
    const res = await updateSignStateApi(param)
    return res
  },
  // 新增签到活动
  async addSignActivityAction(context, param) {
    const res = await addSignActivityApi(param)
    return res
  },
  // 更新签到活动
  async updateSignActivityAction(context, param) {
    const res = await updateSignActivityApi(param)
    return res
  },
  // 根据id获取签到活动详情
  async getSignActivityByIdAction(context, param) {
    const res = await getSignActivityByIdApi(param)
    return res
  },
  // 根据商机id获取商机导入的扩展记录信息
  async getBusinessOpporImportExtendByIdAction(context, param) {
    const res = await getBusinessOpporImportExtendByIdApi(param)
    return res
  },
  // 更改满额减免活动状态
  async updateMejmStateAction(context, param) {
    const res = await updateMejmStateApi(param)
    return res
  },
  // 设置团长规则
  async setCommunityBuyingRuleAction(context, param) {
    const res = await setCommunityBuyingRuleApi(param)
    return res
  },
  // 添加社区团长
  async addCommunityLeaderAction(context, param) {
    const res = await addCommunityLeaderApi(param)
    return res
  },
  // 修改社区团长
  async updateCommunityLeaderAction(context, param) {
    const res = await updateCommunityLeaderApi(param)
    return res
  },
  // 设置社区团长状态
  async setCommunityLeaderStateAction(context, param) {
    const res = await setCommunityLeaderStateApi(param)
    return res
  },
  // 查询社区团长列表
  async queryCommunityLeaderAction(context, param) {
    const res = await queryCommunityLeaderApi(param)
    return res
  },
  // 获取团长规则信息
  async getCommunityBuyingRuleAction(context, param) {
    const res = await getCommunityBuyingRuleApi(param)
    return res
  },
  // 获取社区团长信息
  async getCommunityLeaderByIdAction(context, param) {
    const res = await getCommunityLeaderByIdApi(param)
    return res
  },
  // 分销提现申请记录
  async queryBrandUserRedAccountAction(context, param) {
    const res = await queryBrandUserRedAccountApi(param)
    return res
  },
  // 同意提现申请记录
  async agreeWithdrawalAction(context, param) {
    const res = await agreeWithdrawalApi(param)
    return res
  },
  // 营销活动排序
  async sortMarketingActivityAction(context, param) {
    const res = await sortMarketingActivityApi(param)
    return res
  },
  // 查询分销团队
  async queryDitrubtionGroupAction(context, param) {
    const res = await queryDitrubtionGroupApi(param)
    return res
  },
  // 积分商城排序
  async updateMarketingActivitySortNumAction(context, param) {
    const res = await updateMarketingActivitySortNumApi(param)
    return res
  },
  // 保存分销活动
  async saveDistributionActivityAction(context, param) {
    const res = await saveDistributionActivityApi(param)
    return res
  },
  // 获取品牌分销活动详情
  async getBrandDistributionActivityAction(context, param) {
    const res = await getBrandDistributionActivityApi(param)
    return res
  },
  // 更改活动状态——分销活动
  async updateDistributionStateAction(context, param) {
    const res = await updateDistributionStateApi(param)
    return res
  },
  // 获取我的下级人员信息
  async getDistributionSubsAction(context, param) {
    const res = await getDistributionSubsApi(param)
    return res
  },
  // 获取品牌分销商
  async getBrandDistributionPersonsAction(context, param) {
    const res = await getBrandDistributionPersonsApi(param)
    return res
  },
  // 分销商审核
  async auditDistributionPersonAction(context, param) {
    const res = await auditDistributionPersonApi(param)
    return res
  },
  // 分销注册(注册成为分销商、活动会员、订单会员)
  async registerDistributionRelationshipAction(context, param) {
    const res = await registerDistributionRelationshipApi(param)
    return res
  },
  // 查询弹出商品对应电子券列表
  async queryTicketTCSPListAction(context, param) {
    const res = await queryTicketTCSPListApi(param)
    return res
  },
  // 弹出商品领券
  async receiveTicketTCSPAction(context, param) {
    const res = await receiveTicketTCSPApi(param)
    return res
  },
  // 查询活动对应的砍价记录
  async queryActivityCutListAction(context, param) {
    const res = await queryActivityCutListApi(param)
    return res
  },
  // 添加抽奖活动
  async addPrizeActivityAction(context, param) {
    const res = await addPrizeActivityApi(param)
    return res
  },
  // 更新抽奖活动
  async updatePrizeActivityAction(context, param) {
    const res = await updatePrizeActivityApi(param)
    return res
  },
  // 根据id获取抽奖活动
  async getPrizeActivityByIdAction(context, param) {
    const res = await getPrizeActivityByIdApi(param)
    return res
  },
  // 查询抽奖活动(用于管理平台)
  async queryPrizeActivityForManageAction(context, param) {
    const res = await queryPrizeActivityForManageApi(param)
    return res
  },
  // 获取奖品列表和中奖数
  async getPrizeGoodsListAndWinPrizeNumAction(context, param) {
    const res = await getPrizeGoodsListAndWinPrizeNumApi(param)
    return res
  },
  // 查询中奖参与和奖品
  async queryWinPrizePartakeAndPrizeGoodsAction(context, param) {
    const res = await queryWinPrizePartakeAndPrizeGoodsApi(param)
    return res
  },
  // 设置抽奖活动状态
  async setPrizeActivityStateAction(context, param) {
    const res = await setPrizeActivityStateApi(param)
    return res
  },
  // 获取电子券Bean列表
  async getTicketBeanListAction(context, param) {
    const res = await getTicketBeanListApi(param)
    return res
  },
  // 手动开奖
  async manualOpenPrizeAction(context, param) {
    const res = await manualOpenPrizeApi(param)
    return res
  },
  // 添加公告
  async addBrandNoticeAction(context, param) {
    const res = await addBrandNoticeApi(param)
    return res
  },
  // 删除公告
  async deleteBrandNoticeAction(context, param) {
    const res = await deleteBrandNoticeApi(param)
    return res
  },
  // 更新公告
  async updateBrandNoticeAction(context, param) {
    const res = await updateBrandNoticeApi(param)
    return res
  },
  // 根据id获取公告
  async getBrandNoticeByIdAction(context, param) {
    const res = await getBrandNoticeByIdApi(param)
    return res
  },
  // 外卖红包——新增/更新配置
  async saveOrUpdateTakeoutConfigAction(context, param) {
    const res = await saveOrUpdateTakeoutConfigApi(param)
    return res
  },
  // 外卖红包——获得配置信息
  async getTakeoutConfigAction(context, param) {
    const res = await getTakeoutConfigApi(param)
    return res
  },
  // 获取公告列表
  async getBrandNoticeListAction(context, param) {
    const res = await getBrandNoticeListApi(param)
    return res
  },
  // 系统账户提现申请
  async applyForWithdrawalForAccountAction(context, param) {
    const res = await applyForWithdrawalForAccountApi(param)
    return res
  },
  // 根据品牌获得高级分销信息
  async getDisConfigByBrandIdAction(context, param) {
    const res = await getDisConfigByBrandIdApi(param)
    return res
  },
  // 保存/更新高级分销配置
  async saveOrUpdateDisConfigAction(context, param) {
    const res = await saveOrUpdateDisConfigApi(param)
    return res
  },
  // 查询高级分销注册订单
  async queryTopRegisterOrderAction(context, param) {
    const res = await queryTopRegisterOrderApi(param)
    return res
  },
  // 外卖订单查询
  async queryTakeoutOrderAction(context, param) {
    const res = await queryTakeoutOrderApi(param)
    return res
  },
  // 电影订单查询
  async queyrMovieOrderAction(context, param) {
    const res = await queyrMovieOrderApi(param)
    return res
  },
  // 电影订单查询
  async queryBrandUserGroupAction(context, param) {
    const res = await queryBrandUserGroupApi(param)
    return res
  },
  // 增加品牌用户分组
  async addBrandUserGroupAction(context, param) {
    const res = await addBrandUserGroupApi(param)
    return res
  },
  // 删除品牌用户分组
  async deleteBrandUserGroupAction(context, param) {
    const res = await deleteBrandUserGroupApi(param)
    return res
  },
  // 获取高级分销商品接口
  async queryDisGoodsAction(context, param) {
    const res = await queryDisGoodsApi(param)
    return res
  },
  // 查询导出记录合计
  async queryExportRecordTotalAction(context, param) {
    const res = await queryExportRecordTotalApi(param)
    return res
  },
  // 查询制卡信息合计
  async queryCardMakeRecordTotalAction(context, param) {
    const res = await queryCardMakeRecordTotalApi(param)
    return res
  },
  // 操作分销商
  async operateDistributorAction(context, param) {
    const res = await operateDistributorApi(param)
    return res
  },
  // 新增/更新奖金池配置
  async saveOrUpdateBonusPoolConfigAction(context, param) {
    const res = await saveOrUpdateBonusPoolConfigApi(param)
    return res
  },
  // 获取品牌奖金池配置
  async getBrandBonusPoolConfigAction(context, param) {
    const res = await getBrandBonusPoolConfigApi(param)
    return res
  },
  // cps配置信息查询
  async queryTakeoutConfigAction(context, param) {
    const res = await queryTakeoutConfigApi(param)
    return res
  },
  // 渠道id新增与更新接口
  async saveOrUpdateTbkRelationIdAction(context, param) {
    const res = await saveOrUpdateTbkRelationIdApi(param)
    return res
  },
  // 查询渠道关系id
  async queryTbkRelationIdsAction(context, param) {
    const res = await queryTbkRelationIdsApi(param)
    return res
  },
  // 新增/更新渠道专属pid
  async saveOrUpdateTbkPidAction(context, param) {
    const res = await saveOrUpdateTbkPidApi(param)
    return res
  },
  // 查询推广位
  async queryTbkPidsAction(context, param) {
    const res = await queryTbkPidsApi(param)
    return res
  },
  // 添加门店霸王余额
  async addShopOverlordBalanceAction(context, param) {
    const res = await addShopOverlordBalanceApi(param)
    return res
  },
  // 获取时效卡设置
  async getGivenPeriodCardConfigAction(context, param) {
    const res = await getGivenPeriodCardConfigApi(param)
    return res
  },
  // 获取时效卡设置
  async setGivenPeriodCardConfigAction(context, param) {
    const res = await setGivenPeriodCardConfigApi(param)
    return res
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
